<template lang="pug">
.d-contents
  slot(v-bind="{ upload, progress, loading, uploaded }")
</template>

<script>
import { rServices } from '@/plugins/api';

const mbToBytes = (mb) => Number(mb) * 1024 * 1024;

export default {
  components:  {},
  props: {
    /** RHandler Function([file, progress(), maxSize]) */
    uploadHandler: { type: Function, default: rServices.upload.uploadFile },
    maxSize: { type: Number, default: 10 }, // mb
    maxFiles: { type: Number, default: undefined },
  },
  data() {
    return {
      uploaded: [],

      progress: 0,
      loading: false,
    };
  },
  methods: {
    async upload(filesList = []) {
      if (this.loading) return;
      if (this.maxFiles != null && filesList.length > this.maxFiles) {
        this.$toast.error(this.$tc('event_data.documents.fileLimit', this.maxFiles, { count: this.maxFiles }));
        return;
      }
      const files = [...filesList].filter(({ size, name }) => {
        const maxSize = mbToBytes(this.maxSize);
        const isPassed = !maxSize || size <= maxSize;
        if (!isPassed) {
          this.$toast.error(`Файл «${name}» слишком большой`);
        }
        return isPassed;
      });

      if (files.length) {
        this.uploaded = [];
        this.progress = 0;
        this.loading = true;
        this.$emit('loading', true);
        try {
          const uploadFiles = await this.uploadFiles(files);
          if (uploadFiles?.length && !this.uploaded.length) this.uploaded.push(...uploadFiles);
          if (this.uploaded.length) this.$emit('uploaded', this.uploaded);
        } catch (error) {
          this.$toast.error('Не удалось загрузить файлы. Повторите попытку');
        } finally {
          this.$emit('loading', false);
          this.loading = false;
        }
      }
    },
    async uploadFiles(files) {
      const results = await Promise.allSettled(files.map((file) => this.uploadFile(file)));
      results.forEach((result, index) => {
        if (result.status === 'rejected') this.$toast.error(`Не удалось загрузить файл «${files[index].name}»`);
      });
      return results.filter((result) => result.status === 'fulfilled').map((result) => result.value).filter(Boolean);
    },
    async uploadFile(file) {
      const args = [
        file,
        (progress) => {
          this.progress = progress;
        },
        this.maxSize,
      ];
      const { response, error } = await this.uploadHandler({ args });
      if (error) {
        return null;
      }

      return { data: response?.data?.data, file };
    },
  },
};
</script>
